import * as Yup from 'yup';

const resetPassword = Yup.object().shape({
  email: Yup.string().required('Email is required')
});

export default resetPassword;
